import { gradients } from './constants';

// Code to generate index number from ids is taken from:
// src/master/src/static/gradients/README.md

/**
 * Generate 32bit integer from given string
 */
const hashCode = (str: string): number => {
	let hash = 0;
	let chr: number;
	let i;
	for (i = 0; i < str.length; i++) {
		chr = str.charCodeAt(i);
		hash = (hash << 5) - hash + chr;
		hash = hash & hash; // Convert to 32bit integer
	}

	return hash;
};

export const getGradientIndexByString = (id: string): number => {
	if (!id) {
		return 0;
	}

	const ordinal = (hashCode(id) % 50)
		.toString()
		// split string into character array
		.split('')
		// map to array of charCodes of each character
		.map((chr) => chr.charCodeAt(0))
		// add up all charCodes in the array
		.reduce((a, b) => a + b, 0);

	return ordinal % gradients.length;
};

/**
 * Return color from colorList based on given string
 */
export const getColorFromString = (str: string): string => {
	const index = getGradientIndexByString(str);
	return gradients[index];
};
